export const phrases = {

	'host': 'computadora',
	'hosts': 'computadoras',
	'service': 'servicio',
	'services': 'servicios',

	'pending': 'pendiente',
	'up': 'arriba',
	'down': 'abajo',
	'unreachable': 'inalcanzable',
	'acked': 'admitido',
	'scheduled': 'programado',
	'flapping': 'agitarse',
	'ok': 'bueno',
	'warning': 'aviso',
	'critical': 'crítico',
	'unknown': 'desconocida',
	
	'host up': 'computadora arriba',
	'host down': 'computadora abajo',
	'host unreachable': 'computadora inalcanzable',
	'service ok': 'servicio bueno',
	'service warning': 'servicio aviso',
	'service critical': 'servicio crítico',
	'service unknown': 'servicio desconocida',

	'soft': 'mullido',
	'hard': 'fuerte',

	'Last OK': 'El último tiempo bueno hace',
	'Last UP': 'El último tiempo bueno hace',
	'Last check was': 'La última comprobé fue',
	'Next check in': 'Siguiente comprobé en',
	'ago': '',

	'All': 'Todas las',
	'hosts are UP': 'computadoras son buenas',
	'services are OK': 'servicios son buenas',

	'history': 'historia',
	'alerts in the past': 'alarmas en el anterior',
	'trimming at': 'cortante en el',

	'quiet': 'tranquilo',

	'on': 'en',
	'is': 'es',
	'and': 'y',

	'show filters': 'mostrar filtros',
	'last update': 'última actualización',
	'settings': 'ajustes',

	'newest first': 'los más reciente primero',
	'oldest first': 'los más viejos primero',

	"show more": "mostrar más",
	"show less": "mostrar menos",

	"day": "dia",
	"days": "dias",
	"hour": "hora",
	"hours": "horas",
	"minute": "minuto",
	"minutes": "minutos",
	"second": "segundo",
	"seconds": "segundos"

};